import { app } from './app';

import Axios from "../plugins/axios";
import Emitter from "../plugins/emitter";
import Shop from "../plugins/shop";
import VeeValidate from "../plugins/vee-validate";
import Flatpickr from "../plugins/flatpickr";

[
    Axios,
    Emitter,
    Shop,
    VeeValidate,
    Flatpickr,
].forEach(plugin => app.use(plugin));
